module.exports = __webpack_public_path__ + "8d6d57da15eb1f0305eae738b4067067.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/ear-muffs-red-s.png
// module id = 2180
// module chunks = 0